module.exports = "https://r.nearpod.com/assets/media/image/npp_play_youtube_hover-99da321723e09bbd72d913a6cc2e9ceb.svg";